/**
 * Encapsulate hacked clone functionality for notes and shapes ....
 */



module.exports = {

    /**
     * For now not sub-classing the note models.
     * This function takes a regular note model and turns it into a 'find and redact' note model.
     * Note: this assumes a new note model.
     * For now note it has a flag:
     *  - isFindAndRedactNote
     *  - shape
     *  shapeAttrs: optional -- use for those passed through API ( also implies from API )
     */
    convertNewNote: function( note, shapeAttrs ) {


        // Set flag first prior to shape parse; if parse comes into play with notes, will need to re-think.
        note.isFindAndRedactNote = 1; // only place we are now switch-tracking
        note.isFromAPI = shapeAttrs !== undefined; // set flag to not set last reason codes


        // for now augment with the shape properties preset
        var ShapeConstructorForNote = note.getShapeModel();


        // parentNote sets some properties from higher level note model with current arch ... should decouple
        note.shape = new ShapeConstructorForNote( shapeAttrs ? shapeAttrs : [], {
            parentNote: note
        });

        // Don't really need for top-level dummy shape but put in case
        // TODO: this should handle be subclassing the shape
        note.shape.isFindAndRedactShape = 1;

        // Need to set this on the model so can see what reason codes were added when we perform a search
        // TODO: we may want to change this ....


        if ( note.isRedactionNote() ) {
            note.shape.setSelectedCodeAndFillOnDialogOpen();
        }

        //note.getShape = function() {
        //    return note.shape;
        //}

    },



    /**
     * TOD0: really need a clone note model function
     * TEMP: now also used for created the cloned note models on the searches collection
     *  -- JUST UPDATE THE PAGE NUMBER AND PAGE ID --- ?
     */
    getResultPageNoteModel: function( noteModelOfSearch, page, searchId ) {

        var note = noteModelOfSearch.clone({
            parse: true,
            pageNumber: page.get('number'), // exists in note model.init -- will set the page number
            creationUserGroups: noteModelOfSearch.creationUserGroups // TODO: should have a clone for any/all instance variables
        });

        // TODO: could create a clone of the model that copies the instance variables as well
        // Set the page id -- note could be different page than the current and not set on clone
        note.set( 'pageId', page.get('pageId') );

        // TODO: giving an id makes it save as a modify b/c no longer will be new -- use different attribute???
        //note.set( 'id', 'P' + page.get('pageId') + '_S_'  + searchId );

        // Clone only looks the attribute
        note.isFindAndRedactNote = 1;

        note.shape = this.cloneShapeModel( note, noteModelOfSearch.shape, page );

        return note;

    },


    cloneShapeModel: function( note, shape, page ) {

        // Options uses this sets some properties from the higher level note model w/current arch ... should decouple

        var clonedShape = shape.clone({
            parentNote: note,
            pageModel: page
        });

        // Not in clone -- can rid when subclass -- or override clone
        clonedShape.isFindAndRedactShape = 1;

        if ( note.isRedactionNote() ) {

            var selectedReasonCodes = shape.getReasonCodeCollection();
            if ( selectedReasonCodes ) {
                clonedShape.setReasonCodeCollection( selectedReasonCodes.clone() );
            }

            // Set these first before views are rendered, rather than incorporating in the view logic
            // This should really be part of an extended clone functionality
            clonedShape.setSelectedCodeAndFillOnDialogOpen(
                shape.getSelectedCodesOnDialogOpen().clone(),
                shape.getSelectedFillOnDialogOpen()
            );

        }

        // Could be more in instance variable future -- would need to copy all instance variables
        return clonedShape;

    },


    /**
     *  Overlap here with getResultPageNoteModel --
     *  Data model needs a rewrite badly ...
     *  With multiple searches -- no longer used ... I think we just have getResultPageNoteModel
     */
    cloneFrNoteModel: function( note ) {

        var clone = note.clone({
            parse: true,
            pageNumber: note.pageNumber, // ( inst var )
            creationUserGroups: note.creationUserGroups
        });

        clone.isFindAndRedactNote = 1;

        clone.shape = this.cloneShapeModel( clone, note.shape );

        return clone;

    },


    /* TEMP STOPGAP FOR NOTE EDITING -- lot of refactor and overlap ..... */
    // Attrs are set live in the UI
    // Overlap with did not change from other create note interface ...
    didNoteChange: function( a, b ) {

        if ( a.get('noteType') !== b.get('noteType') )
            return true;


        if ( a.get('title') !== b.get('title') ) {
            return true;
        }

        if ( a.get('accessGroup') !== b.get('accessGroup') )
            return true;


        if ( a.get('reviewGroups') !== b.get('reviewGroups') )
            return true;


        if ( a.get('noteStatus') !== b.get('noteStatus') ) {
            return true;
        }

        if ( a.isRedactionNote() ) {

            if ( a.shape.get('fill') !== b.shape.get('fill') ) {
                return true;
            }

            // Reason Codes ...
            // Could make fn on the reason code collection ... and other ways to handle ... could also be util fn

            var aCodes = a.shape.getReasonCodeCollection().pluck('code'),
                bCodes = b.shape.getReasonCodeCollection().pluck('code');

            if ( _.difference( aCodes, bCodes).length > 0 || _.difference( bCodes, aCodes).length > 0 ) {
                return true;
            }


        }


        return false;


    }



};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/noteModelConverter.js
 ** module id = 584
 ** module chunks = 0
 **/